/**
 * 数组/对象 扁平化
 *
 * @param {Record} obj 输入对象
 * @return {Object} 扁平化对象
 */
function flatten(obj) {
    var result = {};
    var process = function (key, value) {
        if (Object(value) !== value) {
            if (key) {
                result[key] = value;
            }
        }
        else if (Array.isArray(value)) {
            for (var i = 0; i < value.length; i++) {
                process("".concat(key, "[").concat(i, "]"), value[i]);
            }
            if (value.length === 0 && key) {
                result[key] = [];
            }
        }
        else {
            var objArr = Object.keys(value);
            objArr.forEach(function (item) {
                process(key ? "".concat(key, "[").concat(item, "]") : "".concat(item), value[item]);
            });
            if (objArr.length === 0 && key) {
                result[key] = {};
            }
        }
    };
    process('', obj);
    return result;
}

export { flatten as f };
//# sourceMappingURL=flatten-8cecedd9.js.map
